import { observable, action } from 'mobx';
import { getUserLocale } from '../apis/LocalizationApi';

export default class LocalizationStore {
  @observable locale = 'en-us';

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  async init() {
    this.getUserLocale();
  }

  @action
  async getUserLocale() {
    this.locale = getUserLocale();
    return this.locale;
  }
}



// WEBPACK FOOTER //
// ./src/stores/LocalizationStore.js